import { render, staticRenderFns } from "./StudentsNotesTypes.html?vue&type=template&id=674c05ee&external"
import script from "./StudentsNotesTypes.js?vue&type=script&lang=js&external"
export * from "./StudentsNotesTypes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports